// oxlint-disable-next-line no-restricted-imports
import { Checkbox as MantineCheckbox } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";

import classes from "./Checkbox.module.css";

type CheckboxSize = "sm" | "md";
type CheckboxProps = {
  size?: CheckboxSize;
  label?: React.ReactNode;
  labelPosition?: "left" | "right";
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  error?: React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  value?: string;
  id?: string;
  "aria-label"?: string;
};

const SIZE_MAP: Record<CheckboxSize, string> = {
  sm: spacing[4],
  md: spacing[5],
};

const Checkbox = ({
  size = "sm",
  label,
  labelPosition = "right",
  checked,
  indeterminate,
  disabled,
  error,
  onChange,
  name,
  value,
  id,
  "aria-label": ariaLabel,
}: CheckboxProps) => {
  return (
    <MantineCheckbox
      size={SIZE_MAP[size]}
      label={label}
      labelPosition={labelPosition}
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      error={error}
      onChange={onChange}
      name={name}
      value={value}
      id={id}
      aria-label={ariaLabel}
      radius={radius.tiny}
      classNames={{
        input: classes.input,
        label: classes.label,
        body: classes.body,
      }}
      style={
        {
          "--cb-bg-checked": colors.bg.button.primary.default,
          "--cb-bg-checked-active": colors.bg.button.primary.hover,
          "--cb-bg-indeterminate": colors.bg.elevation.primary,
          "--cb-border-hover": colors.border.primaryDefault,
          "--cb-border-checked": colors.border.primaryDefault,
          "--cb-border-indeterminate": colors.border.tertiary,
          "--cb-border-error": colors.border.error.primary,
          "--cb-bg-error-checked": colors.bg.button.destructive.default,
          "--cb-label-color": colors.text.primaryDefault,
          "--cb-label-color-disabled": colors.text.primaryDisabled,
          "--cb-bg-disabled": colors.bg.button.custom.disabled,
        } as React.CSSProperties
      }
    />
  );
};

export { Checkbox };
